import type { TFunction } from 'i18next';

/**
 * Panel title counts unique document cards and link cards separately.
 * Document-only stays on the existing `Sources (n)` string.
 */
export function formatSourcesPanelTitle(
  t: TFunction,
  documentCount: number,
  linkCount: number
): string {
  if (documentCount > 0 && linkCount > 0) {
    return t('app.aiAssistant.sourcesTitleDocumentsAndLinks', {
      documents: t('app.aiAssistant.sourcesDocumentCount', {
        count: documentCount,
      }),
      links: t('app.aiAssistant.sourcesLinkCount', { count: linkCount }),
    });
  }

  if (linkCount > 0) {
    return t('app.aiAssistant.sourcesTitleLinks', { count: linkCount });
  }

  return t('app.aiAssistant.sourcesTitle', { count: documentCount });
}
